var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgActionLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 12.5,
  r: 12.5,
  fill: "#0CAED1"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 12c-.733 0-1.333-.6-1.333-1.333 0-.734.6-1.334 1.333-1.334s1.333.6 1.333 1.334c0 .733-.6 1.333-1.333 1.333Zm4-1.2c0-2.42-1.767-4.133-4-4.133S8 8.38 8 10.8c0 1.56 1.3 3.627 4 6.093 2.7-2.466 4-4.533 4-6.093Zm-4-5.467c2.8 0 5.333 2.147 5.333 5.467 0 2.213-1.78 4.833-5.333 7.867-3.553-3.034-5.333-5.654-5.333-7.867C6.667 7.48 9.2 5.333 12 5.333Z",
  fill: "#fff"
})));
export { SvgActionLocation as ReactComponent };
export default __webpack_public_path__ + "images/action-location.svg";